import { render, staticRenderFns } from "./prefs.vue?vue&type=template&id=4d5c929a&scoped=true&"
import script from "./prefs.vue?vue&type=script&lang=js&"
export * from "./prefs.vue?vue&type=script&lang=js&"
import style0 from "./prefs.vue?vue&type=style&index=0&id=4d5c929a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c929a",
  null
  
)

export default component.exports